import { citations, substances, tgitems } from '@Constants';
import AppStorage from '@Services/AppStorage';
import Catalyst from '@Services/Catalyst';
import { AA_CACHED_HEATMAP_KEY } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const trackHeatmap = (relativeContextsImmutable, { hitSetKey }) => {
  const heatmapAdobeTrackingConfig = {
    [citations]: 0,
    [tgitems]: 0,
    [substances]: 0,
  };

  const configKeys = Object.keys(heatmapAdobeTrackingConfig);
  configKeys.forEach((context) => {
    const itemImmutable = relativeContextsImmutable.get(context);
    if (!itemImmutable) {
      return;
    }
    heatmapAdobeTrackingConfig[context] = itemImmutable.get('resultSize');
  });

  const cachedObject = AppStorage.instance.getFromSessionStorage(AA_CACHED_HEATMAP_KEY) || {};
  const cachedResult = cachedObject[hitSetKey] || {};
  const skipTracking = cachedResult && configKeys.every((key) => cachedResult[key] === heatmapAdobeTrackingConfig[key]);

  if (!skipTracking) {
    const eventData = {
      content: [
        {
          id: 'heatmap',
          type: 'rx2:results:heatmap:substances',
          documents: heatmapAdobeTrackingConfig[substances],
        },
        {
          id: 'heatmap',
          type: 'rx2:results:heatmap:target',
          documents: heatmapAdobeTrackingConfig[tgitems],
        },
        {
          id: 'heatmap',
          type: 'rx2:results:heatmap:citations',
          documents: heatmapAdobeTrackingConfig[citations],
        },
      ],
    };

    Catalyst.trackEvent('contentView', eventData);

    AppStorage.instance.setToSessionStorage(AA_CACHED_HEATMAP_KEY, {
      ...cachedObject,
      [hitSetKey]: heatmapAdobeTrackingConfig,
    });
  }
};
